import dealsReducer from './slice';

export * from './utils';
export * from './slice';
export default dealsReducer;
